import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitojaipurtaxi() {



    const cardData = {

keyword: "Mumbai to Jaipur Taxi",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Jaipur Cab services for families, tourists, business travelers, corporate clients, and long-distance outstation passengers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth interstate journey. Whether you need a Mumbai to Jaipur Taxi, Mumbai to Jaipur Cab Booking, Mumbai to Jaipur One Way Cab, Round Trip Cab, SUV Cab, Innova Cab, Overnight Cab, or Mumbai Airport to Jaipur Cab, we provide affordable and transparent pricing with 24/7 customer support. With doorstep pickup from Mumbai, Navi Mumbai, and Thane, we ensure a hassle-free travel experience to Jaipur, the Pink City of India, renowned for its royal palaces, magnificent forts, vibrant markets, rich heritage, and cultural attractions.",

topPlaces: [
    {
        title: "Amber Fort",
        description:
            "Amber Fort is one of Jaipur's most iconic landmarks and a UNESCO World Heritage Site known for its magnificent Rajput architecture, grand courtyards, intricate mirror work, and stunning hilltop location. Built with red sandstone and marble, the fort offers breathtaking views of Maota Lake and the surrounding Aravalli Hills. Visitors can explore royal halls, historic gateways, beautiful gardens, and learn about the glorious history of Rajasthan's royal dynasties."
    },
    {
        title: "City Palace",
        description:
            "City Palace is a spectacular royal complex located in the heart of Jaipur and continues to serve as the residence of the Jaipur royal family. The palace showcases a blend of Mughal and Rajput architectural styles, featuring elegant courtyards, museums, royal artifacts, colorful gateways, and historical galleries. Visitors gain insight into Jaipur's royal heritage while admiring the grandeur and cultural richness of this magnificent landmark."
    },
    {
        title: "Hawa Mahal",
        description:
            "Hawa Mahal, also known as the Palace of Winds, is one of the most recognizable monuments in India. Its unique honeycomb-shaped façade contains hundreds of intricately designed windows that allowed royal women to observe city life without being seen. The stunning architecture, historical significance, and central location make Hawa Mahal a must-visit attraction during a Mumbai to Jaipur cab journey."
    },
    {
        title: "Jantar Mantar",
        description:
            "Jantar Mantar is a UNESCO World Heritage Site featuring the world's largest stone sundial and a collection of astronomical instruments built by Maharaja Sawai Jai Singh II. The observatory demonstrates advanced scientific knowledge and architectural brilliance from centuries ago. Visitors are fascinated by its precision, historical importance, and contribution to astronomy."
    },
    {
        title: "Nahargarh Fort",
        description:
            "Nahargarh Fort stands atop the Aravalli Hills and offers panoramic views of Jaipur city. The fort served as a defensive structure and royal retreat, featuring beautiful architecture, historic chambers, and scenic viewpoints. Visitors enjoy breathtaking sunset views, photography opportunities, and exploring one of Jaipur's most picturesque heritage attractions."
    },
    {
        title: "Jaigarh Fort",
        description:
            "Jaigarh Fort is famous for housing the world's largest cannon on wheels, Jaivana Cannon. The fort is known for its massive walls, military structures, underground passages, and commanding views of Amber Fort and Jaipur city. History enthusiasts appreciate its strategic importance and well-preserved architecture that reflects Rajasthan's martial heritage."
    },
    {
        title: "Albert Hall Museum",
        description:
            "Albert Hall Museum is the oldest museum in Rajasthan and houses an extensive collection of paintings, sculptures, carpets, textiles, weapons, and artifacts from different periods. The Indo-Saracenic architecture of the building itself is a major attraction. Visitors explore the museum to learn about Rajasthan's rich cultural and artistic legacy."
    },
    {
        title: "Jal Mahal",
        description:
            "Jal Mahal, or the Water Palace, is a stunning architectural marvel situated in the middle of Man Sagar Lake. Surrounded by calm waters and scenic hills, the palace creates a picturesque setting that attracts photographers and tourists alike. Visitors enjoy lakeside views, bird watching, and the serene beauty of one of Jaipur's most photographed landmarks."
    },
    {
        title: "Birla Mandir",
        description:
            "Birla Mandir is a beautiful white marble temple dedicated to Lord Vishnu and Goddess Lakshmi. The temple is admired for its elegant architecture, peaceful atmosphere, intricate carvings, and spiritual significance. Visitors come to seek blessings, admire the craftsmanship, and enjoy the tranquil surroundings that provide a welcome contrast to the bustling city."
    },
    {
        title: "Johari Bazaar and Bapu Bazaar",
        description:
            "Johari Bazaar and Bapu Bazaar are among Jaipur's most famous shopping destinations, offering traditional jewelry, gemstones, textiles, handicrafts, leather products, and Rajasthani souvenirs. The colorful markets showcase the city's vibrant culture and craftsmanship. Visitors enjoy shopping, tasting local cuisine, and experiencing the lively atmosphere that makes Jaipur one of India's most captivating cultural destinations."
    }
],



services: [
{
name: "Mumbai to Jaipur Taxi",
description: "Mumbai Airport Cab offers Mumbai to Jaipur Taxi service for safe, comfortable, and affordable long-distance travel between Mumbai and Jaipur. Whether you are travelling for business meetings, corporate trips, family vacations, tourism, wedding travel, educational tours, or group journeys, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, Force Urbania, and luxury vehicles. Our professional chauffeurs ensure a smooth interstate journey with doorstep pickup, flexible schedules, one way and round trip options, transparent pricing, and 24x7 booking support. We provide convenient pickup services from Mumbai City, Mumbai Airport, Navi Mumbai, Thane, and nearby locations, ensuring a reliable and hassle-free travel experience to Jaipur."
},
{
name: "Mumbai to Jaipur Cab",
description: "Book Mumbai to Jaipur Cab with Mumbai Airport Cab for reliable and comfortable interstate transportation. Our experienced drivers, clean AC vehicles, affordable fares, and flexible travel options make every journey convenient for families, tourists, corporate travellers, and business clients."
},
{
name: "Mumbai to Jaipur Taxi Fare",
description: "Get affordable Mumbai to Jaipur Taxi Fare with Mumbai Airport Cab. We offer transparent pricing, no hidden charges, multiple vehicle choices, and cost-effective travel packages for one way and round trip bookings."
},
{
name: "Mumbai to Jaipur Cab Fare",
description: "Mumbai Airport Cab provides competitive Mumbai to Jaipur Cab Fare with professional chauffeurs, premium vehicles, dependable service, and flexible travel plans suitable for all types of travellers."
},
{
name: "Cab from Mumbai to Jaipur",
description: "Choose a Cab from Mumbai to Jaipur with Mumbai Airport Cab and enjoy safe, comfortable, and reliable transportation with experienced drivers and well-maintained AC vehicles for long-distance travel."
},
{
name: "Mumbai to Jaipur Car Rental",
description: "Book Mumbai to Jaipur Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, Tempo Traveller, and luxury vehicles for a flexible and comfortable travel experience across states."
},
{
name: "Mumbai to Jaipur Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Jaipur Cab Booking with instant confirmation, 24x7 customer support, professional drivers, and multiple vehicle options suitable for individual, family, and corporate travel."
},
{
name: "Mumbai to Jaipur One Way Cab",
description: "Travel conveniently with Mumbai to Jaipur One Way Cab service featuring fixed pricing, comfortable AC vehicles, professional chauffeurs, and hassle-free pickup and drop facilities."
},
{
name: "Mumbai to Jaipur Round Trip Cab",
description: "Mumbai Airport Cab provides Mumbai to Jaipur Round Trip Cab packages for business travel, family vacations, wedding trips, tourism, and extended interstate journeys with flexible schedules and reliable service."
},
{
name: "Mumbai to Jaipur Outstation Cab",
description: "Book Mumbai to Jaipur Outstation Cab for comfortable long-distance travel with premium vehicles, experienced drivers, affordable rates, customized travel packages, and dependable customer support."
},
{
name: "Mumbai to Jaipur Taxi Service",
description: "Mumbai Airport Cab offers Mumbai to Jaipur Taxi Service with safe transportation, clean AC vehicles, affordable pricing, professional chauffeurs, and reliable customer assistance throughout the journey."
},
{
name: "Mumbai to Jaipur Car Hire",
description: "Choose Mumbai to Jaipur Car Hire with Mumbai Airport Cab for premium chauffeur-driven transportation featuring comfortable seating, flexible schedules, personalized service, and smooth interstate travel experience."
},
{
name: "Mumbai to Jaipur Long Distance Taxi",
description: "Mumbai Airport Cab specializes in Mumbai to Jaipur Long Distance Taxi service with experienced drivers, well-maintained vehicles, route planning support, and safe overnight travel options for long journeys."
},
{
name: "Mumbai to Jaipur Overnight Cab",
description: "Book Mumbai to Jaipur Overnight Cab with Mumbai Airport Cab for safe night travel, comfortable seating, professional chauffeurs, and reliable interstate transportation with rest-friendly driving schedules."
},
{
name: "Mumbai to Jaipur SUV Cab",
description: "Mumbai Airport Cab provides Mumbai to Jaipur SUV Cab service for larger families, corporate groups, and long-distance travellers seeking spacious interiors, premium comfort, and ample luggage capacity."
},
{
name: "Mumbai to Jaipur Innova Cab",
description: "Book Mumbai to Jaipur Innova Cab with Mumbai Airport Cab for spacious seating, premium comfort, professional chauffeur service, and reliable long-distance transportation for families and groups."
},
{
name: "Mumbai Airport to Jaipur Cab",
description: "Book Mumbai Airport to Jaipur Cab with direct pickup from domestic and international terminals. We provide flight tracking, luggage assistance, professional chauffeurs, and comfortable AC vehicles for stress-free travel."
},
{
name: "Navi Mumbai to Jaipur Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Jaipur Cab service with doorstep pickup, affordable fares, premium vehicles, and reliable interstate transportation for business and leisure travellers."
},
{
name: "Thane to Jaipur Cab",
description: "Choose Thane to Jaipur Cab with Mumbai Airport Cab for reliable transportation, professional drivers, comfortable vehicles, and flexible travel schedules designed for smooth long-distance journeys."
}
],

tableData: [
["Mumbai to Jaipur Taxi","Mumbai to Jaipur Cab"],
["Mumbai to Jaipur Taxi Fare","Mumbai to Jaipur Cab Fare"],
["Cab from Mumbai to Jaipur","Mumbai to Jaipur Car Rental"],
["Mumbai to Jaipur Cab Booking","Mumbai to Jaipur One Way Cab"],
["Mumbai to Jaipur Round Trip Cab","Mumbai to Jaipur Outstation Cab"],
["Mumbai to Jaipur Taxi Service","Mumbai to Jaipur Car Hire"],
["Mumbai to Jaipur Long Distance Taxi","Mumbai to Jaipur Overnight Cab"],
["Mumbai to Jaipur SUV Cab","Mumbai to Jaipur Innova Cab"],
["Mumbai Airport to Jaipur Cab","Navi Mumbai to Jaipur Cab"],
["Thane to Jaipur Cab","Mumbai to Jaipur Family Travel Cab"]
],



whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Jaipur Taxi Service",
WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Jaipur Taxi transportation for business travelers, families, tourists, professionals, and long-distance travelers seeking a comfortable journey."
},
{
WhyChooseheading: "Convenient Interstate Travel Experience",
WhyChoosedescription: "Our taxi service offers hassle-free connectivity between Mumbai and Jaipur for vacations, corporate travel, family visits, educational purposes, and special occasions."
},
{
WhyChooseheading: "Perfect for Tourism and Heritage Travel",
WhyChoosedescription: "Jaipur, known as the Pink City, attracts visitors from across India for its forts, palaces, cultural heritage, shopping destinations, and historical landmarks."
},
{
WhyChooseheading: "Wide Range of Vehicle Options",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel requirements."
},
{
WhyChooseheading: "One-Way and Round Trip Booking",
WhyChoosedescription: "Whether you need a one-way transfer, round trip, multi-day vacation, or customized Rajasthan tour package, we provide flexible booking options."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Chauffeurs",
WhyChoosedescription: "Our experienced drivers and regularly maintained vehicles ensure safe, comfortable, and stress-free travel throughout the long-distance journey."
},
{
WhyChooseheading: "Suitable for Families and Group Tours",
WhyChoosedescription: "From solo travelers to large family groups, we provide suitable vehicle options for sightseeing tours, family functions, business trips, and holiday packages."
}
]
};

const faqData = [
{
question: "Why do travelers book Mumbai to Jaipur Taxi services?",
answer: "Jaipur is one of India's most popular tourist destinations, famous for its forts, palaces, culture, shopping markets, and royal heritage."
},
{
question: "Can I book a one-way taxi from Mumbai to Jaipur?",
answer: "Yes, one-way taxi services are available along with round-trip and customized Rajasthan travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Jaipur travel?",
answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, and Tempo Travellers are preferred choices for comfortable long-distance travel."
},
{
question: "Do you provide multi-day Jaipur tour packages?",
answer: "Yes, customers can choose multi-day travel packages including Jaipur sightseeing and nearby Rajasthan destinations."
},
{
question: "Can tourists use this service for Rajasthan tours?",
answer: "Yes, many tourists choose Mumbai Airport Cabs for Jaipur vacations, heritage tours, and Rajasthan sightseeing trips."
},
{
question: "Are Tempo Travellers available for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate teams, and tour groups."
},
{
question: "Can I get pickup from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
},
{
question: "Can multiple sightseeing stops be added during the journey?",
answer: "Yes, customers can customize their itinerary and include tourist attractions, religious places, and personal stops."
},
{
question: "Is advance booking recommended for Mumbai to Jaipur travel?",
answer: "Yes, advance booking is highly recommended to secure your preferred vehicle and ensure proper travel planning."
},
{
question: "How can I book a Mumbai to Jaipur Taxi?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Deepak Sharma",
feedback:
"The Mumbai to Jaipur journey was managed exceptionally well. The cab was comfortable for long-distance travel and the driver was professional throughout the trip.",
rating: 5
},
{
id: 2,
name: "Mrs. Kavita Singh",
feedback:
"Mumbai Airport Cabs provided outstanding service for our Rajasthan vacation. The vehicle was clean, spacious, and the travel experience was smooth from start to finish.",
rating: 5
}
];








































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Jaipur Taxi",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-jaipur-cab.jpg",
"description": "Book Mumbai to Jaipur taxi service for safe, comfortable, and affordable long-distance travel. Mumbai Airport Cabs offers reliable intercity cab service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options between Mumbai and Jaipur.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-jaipur-taxi"
}
};






    return (
        <div>

<Helmet>
  <title>Mumbai to Jaipur Taxi | Cab Service & Fare | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Jaipur taxi service at affordable fares. Reliable long-distance cab service with professional drivers, comfortable cars, SUV and Innova options, and flexible one-way and round-trip travel."
/>

<meta
 name="keywords"
 content="mumbai to jaipur taxi, mumbai to jaipur cab, mumbai to jaipur taxi fare, mumbai to jaipur cab fare, cab from mumbai to jaipur, mumbai to jaipur car rental, mumbai to jaipur cab booking, mumbai to jaipur one way cab, mumbai to jaipur round trip cab, mumbai to jaipur outstation cab, mumbai to jaipur taxi service, mumbai to jaipur car hire, mumbai to jaipur long distance taxi, mumbai to jaipur overnight cab, mumbai to jaipur suv cab, mumbai to jaipur innova cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/89.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitojaipurtaxi;